module.exports = __webpack_public_path__ + "assets/img/active-img2.33be5ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activities/active-img2.jpg
// module id = PwbX
// module chunks = 1